module.exports = __webpack_public_path__ + "static/sekcePlaceholder-600b6f4424e4e47d0cf9a91fddc10bdc.svg";